import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Formik, Form, Field, useFormikContext } from "formik";
import Routes from "security-app/routing/Routes";
import { useStore } from "stores/connect";
import { Button, Modal } from "components/bootstrap";
import { Switch, FormikInput } from "components/common";
import { EventNotificationsActions, EventNotificationsStore } from "stores/event-notifications/EventNotificationsStore";
import useDashboards from "views/components/dashboard/hooks/useDashboards";
import useSavedSearches from "views/hooks/useSavedSearches";
import { FormikSelect, FormikMarkdownEditor } from "security-app/components/common/FormikComponents";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
import { useCreateEventProcedureStep, useUpdateEventProcedureStep } from "security-app/hooks/useEventProceduresAPI";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import SearchQueryForm from "./SearchQueryForm";
import EventProceduresParametersForm from "./EventProceduresParametersForm";
const StyledForm = styled(Form)`
  width: 100%;

  & .form-group {
    width: 100%;
  }
`;
const INIT_EVENT_PROCEDURE_STEP = {
  title: "",
  description: "",
  type: "",
  notification_id: "",
  dashboard_id: "",
  query: "",
  parameters: {},
  use_saved_search: false,
  saved_search: ""
};
const stepTypeOptions = [
  { label: "Search Query", value: "perform_search" },
  { label: "Notification", value: "execute_notification" },
  // { label: 'Link', value: 'link' },
  { label: "Go To Dashboard", value: "go_to_dashboard" }
];
const fetchNotifications = () => {
  EventNotificationsActions.listAll();
};
function EventProcedureStepForm({
  onClose,
  eventProcedureStep = void 0,
  onSave = () => {
  },
  readOnly = false
}) {
  var _a, _b, _c, _d;
  const [stepType, setStepType] = useState(((_b = (_a = eventProcedureStep == null ? void 0 : eventProcedureStep.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type) || "");
  const [showAction, setShowAction] = useState(!!((_c = eventProcedureStep == null ? void 0 : eventProcedureStep.action) == null ? void 0 : _c.config) || false);
  const notifications = useStore(EventNotificationsStore);
  const { data: dashboards } = useDashboards({
    page: 1,
    pageSize: 0,
    query: "",
    sort: { attributeId: "title", direction: "asc" },
    scope: "read"
  });
  const { data: savedSearches } = useSavedSearches({
    query: "",
    page: 1,
    pageSize: 0,
    sort: { direction: "asc", attributeId: "title" }
  });
  const { permissions } = useCurrentUser();
  const { createEventProcedureStep, creatingEventProcedureStep } = useCreateEventProcedureStep();
  const { updateEventProcedureStep, updatingEventProcedureStep } = useUpdateEventProcedureStep();
  useEffect(() => {
    fetchNotifications();
  }, []);
  const getInitialValuesWithStep = () => {
    var _a2, _b2;
    if (!eventProcedureStep) return INIT_EVENT_PROCEDURE_STEP;
    const { title, description, action } = eventProcedureStep;
    let auxConfig = {};
    if (!action) {
      return {
        ...INIT_EVENT_PROCEDURE_STEP,
        title,
        description
      };
    }
    switch (action.config.type) {
      case "execute_notification":
        auxConfig = {
          notification_id: action.config.notification_id
        };
        break;
      case "go_to_dashboard":
        auxConfig = {
          dashboard_id: action.config.dashboard_id,
          parameters: Object.keys((_a2 = action.config) == null ? void 0 : _a2.parameters).length > 0 ? action.config.parameters : {}
        };
        break;
      case "perform_search":
        auxConfig = {
          query: action.config.query,
          parameters: Object.keys((_b2 = action.config) == null ? void 0 : _b2.parameters).length > 0 ? action.config.parameters : {},
          streams: action.config.streams,
          stream_categories: action.config.stream_categories,
          use_saved_search: action.config.use_saved_search,
          saved_search: action.config.saved_search
        };
        break;
      // case 'link':
      //   auxConfig = {
      //     link: action.config.link,
      //   };
      //   break;
      default:
        break;
    }
    return {
      ...INIT_EVENT_PROCEDURE_STEP,
      title,
      description,
      type: action.config.type,
      ...auxConfig
    };
  };
  const formatNotifications = (items) => {
    if (!items || items.length === 0) return [];
    const formattedNotifications = items.map((n) => ({ label: n.title, value: n.id }));
    return formattedNotifications;
  };
  const formatDashboards = (items) => {
    const formattedDashboards = items.list.map((d) => ({ label: d._value.title, value: d._value.id }));
    return formattedDashboards;
  };
  const formatSavedSearches = ((_d = savedSearches == null ? void 0 : savedSearches.list) != null ? _d : []).map(({ id, title }) => ({ value: id, label: title }));
  const onSubmit = (values) => {
    let payloadObj = {
      title: values.title,
      description: values.description
    };
    if (showAction) {
      switch (stepType) {
        case "execute_notification":
          payloadObj = {
            ...payloadObj,
            action: {
              config: {
                type: stepType,
                notification_id: values.notification_id || ""
              }
            }
          };
          break;
        case "go_to_dashboard":
          payloadObj = {
            ...payloadObj,
            action: {
              config: {
                type: stepType,
                dashboard_id: values.dashboard_id,
                parameters: values.parameters
              }
            }
          };
          break;
        case "perform_search":
          payloadObj = {
            ...payloadObj,
            action: {
              config: {
                type: stepType,
                query: values.query,
                use_saved_search: values.use_saved_search,
                saved_search: values.saved_search,
                parameters: values.parameters,
                streams: values.streams,
                stream_categories: values.stream_categories
              }
            }
          };
          break;
        // case 'link':
        //   payloadObj = {
        //     ...payloadObj,
        //     action: {
        //       config: {
        //         type: values.type,
        //         link: values.link,
        //       }
        //     }
        //   };
        //   break;
        default:
          break;
      }
    }
    if (eventProcedureStep == null ? void 0 : eventProcedureStep.id) {
      payloadObj = {
        ...payloadObj,
        id: eventProcedureStep.id,
        _scope: eventProcedureStep._scope
      };
    } else {
      payloadObj = {
        ...payloadObj,
        share_request: values.share_request
      };
    }
    if (eventProcedureStep == null ? void 0 : eventProcedureStep.id) {
      updateEventProcedureStep({ stepId: eventProcedureStep.id, step: payloadObj });
    } else {
      createEventProcedureStep(payloadObj).then((response) => onSave(response));
    }
    onClose();
  };
  const onTypeChange = (value) => {
    setStepType(value);
  };
  const handleCancel = (resetForm) => () => {
    resetForm();
    onClose();
  };
  const preventSubmitOnEnter = (e) => {
    if (e.key === "Enter") return false;
    return true;
  };
  const renderFormType = (values) => {
    switch (stepType) {
      case "execute_notification":
        return /* @__PURE__ */ React.createElement(Field, { name: "notification_id" }, ({ field }) => /* @__PURE__ */ React.createElement(
          FormikSelect,
          {
            field,
            options: formatNotifications(notifications.all),
            clearable: false,
            onChange: field.onChange,
            label: "Select Notification",
            disabled: readOnly,
            menuPlacement: "top"
          }
        ));
      case "go_to_dashboard":
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, { name: "dashboard_id" }, ({ field }) => /* @__PURE__ */ React.createElement(
          FormikSelect,
          {
            field,
            options: formatDashboards(dashboards),
            clearable: false,
            onChange: field.onChange,
            label: "Select Dashboard",
            disabled: readOnly,
            menuPlacement: "top"
          }
        )), (values == null ? void 0 : values.dashboard_id) && isPermitted(permissions, `dashboards:read:${values == null ? void 0 : values.dashboard_id}`) && /* @__PURE__ */ React.createElement(EventProceduresParametersForm, { viewType: "dashboard", viewId: values == null ? void 0 : values.dashboard_id, readOnly }));
      case "perform_search": {
        const loadParameters = (values == null ? void 0 : values.use_saved_search) && (values == null ? void 0 : values.saved_search) && isPermitted(permissions, `view:read:${values == null ? void 0 : values.saved_search}`);
        return /* @__PURE__ */ React.createElement(SearchQueryForm, { savedSearches: formatSavedSearches, readOnly, loadParameters });
      }
      // case 'link':
      //   return (
      //     <Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch">
      //       <ControlLabel>Link</ControlLabel>
      //       <Field name="link" styled={{ width: '100%' }}>
      //         {({ field }) => (
      //           <Input id={field.name}
      //             name={field.name}
      //             placeholder="Link"
      //             type="text"
      //             value={field.value}
      //             onChange={field.onChange}
      //             onBlur={field.onBlur}
      //             bsStyle={(field.error && field.touched) ? 'error' : null} />
      //         )}
      //       </Field>
      //     </Col>
      //   );
      default:
        return null;
    }
  };
  const ParameterResetEffects = () => {
    const { values, setFieldValue } = useFormikContext();
    const prevDashboardIdRef = useRef();
    const prevSavedSearchRef = useRef();
    const hasMounted = useRef(false);
    useEffect(() => {
      if (!hasMounted.current) {
        hasMounted.current = true;
        prevDashboardIdRef.current = values.dashboard_id;
        prevSavedSearchRef.current = values.saved_search;
        return;
      }
      const prevDashboardId = prevDashboardIdRef.current;
      if (stepType === "go_to_dashboard" && values.dashboard_id && values.dashboard_id !== prevDashboardId && !readOnly) {
        setFieldValue("parameters", {});
      }
      prevDashboardIdRef.current = values.dashboard_id;
    }, [values.dashboard_id, values.saved_search, setFieldValue]);
    useEffect(() => {
      const prevSavedSearch = prevSavedSearchRef.current;
      if (stepType === "perform_search" && values.use_saved_search && values.saved_search && values.saved_search !== prevSavedSearch && !readOnly) {
        setFieldValue("parameters", {});
      }
      prevSavedSearchRef.current = values.saved_search;
    }, [values.saved_search, values.use_saved_search, setFieldValue]);
    return null;
  };
  const getTitleMode = () => {
    if (readOnly) return "View";
    if (eventProcedureStep == null ? void 0 : eventProcedureStep.id) return "Edit";
    return "Create";
  };
  const validateValues = async (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Must have a title";
    }
    if (showAction) {
      if (!values.type) {
        errors.type = "Must have an action type";
      } else {
        switch (values.type) {
          case "execute_notification":
            if (!values.notification_id) {
              errors.notification_id = "Must select a notification";
            }
            break;
          case "go_to_dashboard":
            if (!values.dashboard_id) {
              errors.dashboard_id = "Must select a dashboard";
            }
            break;
          case "perform_search":
            if (values.use_saved_search && !values.saved_search) {
              errors.saved_search = "Must select a saved search";
            } else if (!values.use_saved_search && !values.query) {
              errors.query = "Must have a query";
            }
            break;
          // case 'link':
          //   if (!values.link) {
          //     errors.link = 'Must have a link';
          //   }
          //   break;
          default:
            break;
        }
      }
    }
    return errors;
  };
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, bsSize: "lg", isConfirmDialog: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, `${getTitleMode()} Event Procedure Step`)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit,
      initialValues: getInitialValuesWithStep() || INIT_EVENT_PROCEDURE_STEP,
      validate: validateValues
    },
    ({ isSubmitting, isValid, dirty, values, submitForm, resetForm }) => /* @__PURE__ */ React.createElement(StyledForm, { id: "event-procedure-step-form", onKeyDown: preventSubmitOnEnter }, /* @__PURE__ */ React.createElement(ParameterResetEffects, null), /* @__PURE__ */ React.createElement(Col, { $width: "100%" }, /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        type: "text",
        name: "title",
        id: "title",
        label: "Title",
        validate: (value) => !value && "Must have a title",
        required: true,
        disabled: readOnly
      }
    )), /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, /* @__PURE__ */ React.createElement(
      Field,
      {
        id: "event_procedure_step_description",
        name: "description",
        component: FormikMarkdownEditor,
        label: "Description",
        height: 150,
        disabled: readOnly
      }
    )), readOnly && /* @__PURE__ */ React.createElement(Row, { $fullWidth: true, $width: "100%", $justify: "flex-end" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        bsSize: "sm",
        bsStyle: "link",
        href: Routes.CORE_EVENTS.EVENT_PROCEDURES.LIST("steps"),
        target: "_blank",
        rel: "noopener noreferrer"
      },
      "Manage Event Procedure Steps"
    )), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row" } }, /* @__PURE__ */ React.createElement(
      Switch,
      {
        "aria-label": `${showAction ? "Hide" : "Show"} Action Section`,
        id: "toggle_action_section",
        "data-testid": "show-action-toggle",
        checked: showAction,
        onChange: () => setShowAction(!showAction),
        disabled: readOnly
      }
    ), "\xA0Action"), showAction && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, { name: "type", label: "Action Type" }, ({ field }) => /* @__PURE__ */ React.createElement(
      FormikSelect,
      {
        field,
        options: stepTypeOptions,
        onChange: onTypeChange,
        clearable: false,
        label: "Action Type",
        disabled: readOnly
      }
    )), renderFormType(values)), /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end", $width: "100%" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", onClick: handleCancel(resetForm) }, "Cancel"), /* @__PURE__ */ React.createElement(
      Button,
      {
        type: "button",
        bsStyle: "primary",
        onClick: submitForm,
        disabled: readOnly || !isValid || !dirty || creatingEventProcedureStep || updatingEventProcedureStep || isSubmitting
      },
      (eventProcedureStep == null ? void 0 : eventProcedureStep.id) ? "Save" : "Create",
      " Event Procedure Step"
    ))))
  )));
}
export default EventProcedureStepForm;
